/**
 * <strong>Purpose:</strong> <br>
 * Adds aria-labelledBy attribute to the widget.
 * <br><br>
 * <strong>Contract:</strong> <br>
 * The widget should have buttonNode, focusNode, textNode, inlineTextNode and lastTextLineNode. <br>
 * This mixin is dependent upon: <br>
 * {@link module:mw-form/mixins/property/TextMixin} <br>
 *
 * @module mw-form/mixins/SplitTypeButtonsAriaLabelledByMixin
 *
 * @copyright Copyright 2018 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare",
    "mw-form/mixins/property/TextMixin"
], function (declare, TextMixin) {

    var SplitTypeButtonsAriaLabelledByMixin = declare(null, {

        postCreate: function () {
            this.inherited(arguments);

            var textNodeLabel = this.id + "_textNodeLabel";
            var inlineTextNodeLabel = this.id + "_inlineTextNodeLabel";
            var lastTextLineNodeLabel = this.id + "_lastTextLineNodeLabel";
            this.textNode.setAttribute("id", textNodeLabel);
            this.inlineTextNode.setAttribute("id", inlineTextNodeLabel);
            this.lastTextLineNode.setAttribute("id", lastTextLineNodeLabel);

            // textNode can be within a buttonNode or focusNode. So, check where it is, before setting the
            // aria-labelledbv attribute.
            if (this.buttonNode && this.buttonNode.contains(this.textNode)) {
                this.buttonNode.setAttribute("aria-labelledby", textNodeLabel);
            } else {
                // inlineTextNode and lastTextLineNode will always be within the focusNode. Append
                // their ids with the textNode's id so that the screen reader speaks out the
                // entire text.
                this.focusNode.setAttribute("aria-labelledby", textNodeLabel + " "
                    + inlineTextNodeLabel + " " + lastTextLineNodeLabel);
            }
        }
    });

    SplitTypeButtonsAriaLabelledByMixin._dependencies = [
        {mixin: TextMixin, orderDependent: false}
    ];
    return SplitTypeButtonsAriaLabelledByMixin;
});
